/**
 * 档位表：点某一档，把那一行的数量设成该档的起订量（May 2026-08-27 的参考图，
 * 底下那句 "Click a tier to set quantity"）。
 *
 * ⚠️ **必须用事件委托挂在 document 上，不能给每个按钮单独绑。**
 * 订单页每改一次数量，Dawn 的 cart.js 会把整块 `.js-contents` 用服务端新版本替换掉；
 * 抽屉那边换的是整个 `.drawer__inner`。直接绑在按钮上的监听会跟着旧节点一起被丢掉 ——
 * 表现是「第一次点有用，改完数量之后再点就没反应了」，很难查。
 *
 * ⚠️ 设完值要派发一个**冒泡的** change。
 * cart.js 是 `this.addEventListener('change', …)` 挂在 <cart-items> 自定义元素上的
 * （也是委托），不冒泡就传不到它那儿。
 */
(function () {
  /**
   * ── 小问号浮层：点外面能收回去 ──────────────────────────────
   * May 2026-08-27:「问号这里怎么收不回去？」
   *
   * 那几个说明浮层是 <details>/<summary> 做的。<details> 的原生行为是
   * **只有再点一次 summary 才关**，点页面别处它就一直开着 ——
   * 而浮层是绝对定位的，展开后正好压住旁边的金额，看着就像卡死了。
   * （用 <details> 本身是对的：手机上纯 :hover 的气泡根本打不开。）
   *
   * 三件事：点外面关、按 Esc 关、开一个的时候把别的关掉
   * （两个浮层叠在一起比不能关更糟）。
   */
  const closeTips = function (except) {
    document.querySelectorAll('details.torena-tip[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  };

  document.addEventListener('click', function (event) {
    const tip = event.target.closest('details.torena-tip');
    closeTips(tip);           // 点到别的地方 / 点开另一个 → 其余的都收起来
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeTips(null);
  });

  document.addEventListener('click', function (event) {
    const row = event.target.closest('[data-torena-tier-qty]');
    if (!row) return;

    const qty = parseInt(row.dataset.torenaTierQty, 10);
    if (!Number.isFinite(qty) || qty < 1) return;

    // 同一行里的数量输入框。订单页和抽屉的 id 前缀不一样，所以按就近的行找，不按 id
    const line = row.closest('.cart-item');
    const input = line && line.querySelector('.quantity__input');
    if (!input) return;

    // 已经是这个数就什么都不做 —— 否则白跑一趟请求，界面还会闪一下加载态
    if (parseInt(input.value, 10) === qty) return;

    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
